import React, { useMemo } from 'react';
import { FormattedMessage } from 'react-intl';

import { toInternationalFormat } from '../../../../../../../utils/phone/to-international-format';
import { IConfirmationCodeStepDescriptionProps } from './confirmation-code-step-description.models';

export const ConfirmationCodeStepDescription = ({
  stepsState: {
    phone: { formValues: { phoneNumber } },
  },
}: IConfirmationCodeStepDescriptionProps): JSX.Element => {
  const formattedPhoneNumber = useMemo(
    () => toInternationalFormat(phoneNumber),
    [phoneNumber],
  );

  return (
    <FormattedMessage
      id="registration.confirmationCodeStep.description"
      values={{ phoneNumber: formattedPhoneNumber }}
    />
  );
};
